import React, { useState } from "react";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: ""
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Form submitted! (This is a demo)");
  };

  const inputStyle = {
    width: "100%",
    padding: "0.7rem",
    borderRadius: "6px",
    border: "1px solid #ddd",
    outline: "none",
    fontSize: "0.95rem",
    transition: "0.2s",
  };

  return (
    <section
      id="contact"
      style={{
        padding: "4rem 1.5rem",
        backgroundColor: "#f9fafb",
      }}
    >
      <h2
        style={{
          textAlign: "center",
          marginBottom: "2.5rem",
          fontSize: "2rem",
          fontWeight: "600",
          color: "#222",
        }}
      >
        Contact Us
      </h2>

      <div
        style={{
          maxWidth: "1000px",
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: "2rem",
        }}
      >
        {/* LEFT: Agent Info */}
        <div
          style={{
            background: "#fff",
            padding: "2rem",
            borderRadius: "12px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
          }}
        >
          <h3 style={{ marginBottom: "1rem", color: "#222" }}>
            Robert Northfield
          </h3>

          <p style={{ color: "#555", marginBottom: "1rem" }}>
            Keller Williams MidTown Direct – Maplewood
          </p>

          <div style={{ marginBottom: "0.8rem", color: "#444" }}>
            📞 (973) 544-8001
          </div>

          <div style={{ marginBottom: "1.5rem", color: "#444" }}>
            ✉ robertnorthfield@kw.com
          </div>

          <p style={{ fontSize: "0.9rem", color: "#777" }}>
            Reach out for property inquiries, scheduling visits, or more details.
          </p>
        </div>

        {/* RIGHT: Form */}
        <form
          onSubmit={handleSubmit}
          style={{
            background: "#fff",
            padding: "2rem",
            borderRadius: "12px",
            boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
          }}
        >
          <div style={{ marginBottom: "1rem" }}>
            <label>Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              style={inputStyle}
              onFocus={(e) => (e.target.style.border = "1px solid #007bff")}
              onBlur={(e) => (e.target.style.border = "1px solid #ddd")}
            />
          </div>

          <div style={{ marginBottom: "1rem" }}>
            <label>Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              style={inputStyle}
              onFocus={(e) => (e.target.style.border = "1px solid #007bff")}
              onBlur={(e) => (e.target.style.border = "1px solid #ddd")}
            />
          </div>

          <div style={{ marginBottom: "1rem" }}>
            <label>Phone</label>
            <input
              type="tel"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              style={inputStyle}
              onFocus={(e) => (e.target.style.border = "1px solid #007bff")}
              onBlur={(e) => (e.target.style.border = "1px solid #ddd")}
            />
          </div>

          <div style={{ marginBottom: "1.5rem" }}>
            <label>Message</label>
            <textarea
              name="message"
              rows="4"
              value={formData.message}
              onChange={handleChange}
              style={inputStyle}
              onFocus={(e) => (e.target.style.border = "1px solid #007bff")}
              onBlur={(e) => (e.target.style.border = "1px solid #ddd")}
            />
          </div>

          <button
            type="submit"
            style={{
              width: "100%",
              padding: "0.9rem",
              backgroundColor: "#007bff",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              fontSize: "1rem",
              fontWeight: "500",
              cursor: "pointer",
              transition: "0.3s",
            }}
            onMouseEnter={(e) =>
              (e.target.style.backgroundColor = "#0056b3")
            }
            onMouseLeave={(e) =>
              (e.target.style.backgroundColor = "#007bff")
            }
          >
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact; 